import React from 'react';
import { Navbar, Container, Button, Row, Input, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FadeLoader } from 'react-spinners';
import ReactGA from 'react-ga';

import {
	//New fields
	inputSchoolName,
	inputClassName,
	inputCommitteePresident,
	inputCommitteePhone,
	inputCommitteeEmail,
	inputClassPresident,
	inputClassPhone,
	inputClassEmail,
	inputDateProm,
	inputGuestsNumber,
	// New regular fields
	inputPhone,
	inputDateEvent,
	inputTypeEvent,
	// Original fields
	inputName,
	inputEmail,
	inputMsg,
	sendContact,
	getContactDB,
	setContactStatus
} from '../actions/ContactActions';

import { emailValid } from '../utils';

class Contact extends React.Component {
	state = {
		// New fields
		schoolNameError: false,
		classNameError: false,
		commPresidentError: false,
		commPhoneError: false,
		commEmailError: false,
		classPresidentError: false,
		classPhoneError: false,
		classEmailError: false,
		datePromError: false,
		guestsNumberError: false,
		// New regular fields
		phoneError: false,
		dateEventError: false,
		typeEventError: false,
		// Original fields
		nameError: false,
		invalid: false,
		msgError: false
	}

	timeout = null;

	componentWillMount() {
		ReactGA.pageview('/Contact');
		this.props.getContactDB();
		this.props.setContactStatus('');
	}

	componentWillUpdate(nextProps, nextState) {
		if (nextProps.status !== this.props.status && nextProps.status === 'ok') {
			this.timeout = setTimeout(() => {
				this._goHome();
			}, 5000);
		}
	}

	_goBack() {
		this.props.history.goBack();
	}

	_goScreen(screen) {
		this.props.history.push(screen);
	}

	_goHome(){
		this._goScreen('home');
	}

	_send(){
		// New fields
		let schoolNameError = false;
		let classNameError = false;
		let commPresidentError = false;
		let commPhoneError = false;
		let commEmailError = false;
		let classPresidentError = false;
		let classPhoneError = false;
		let classEmailError = false;
		let datePromError = false;
		let guestsNumberError = false;
		// New regular fields
		let phoneError = false;
		let dateEventError = false;
		let typeEventError = false;
		// Original fields
		let invalid = false;
		let nameError = false;
		let msgError = false;

		// New fields
		if (!this.props.schoolName) schoolNameError = true;
		if (!this.props.className) classNameError = true;
		if (!this.props.commPresident) commPresidentError = true;
		if (!this.props.commPhone) commPhoneError = true;
		if (!emailValid(this.props.commEmail)) commEmailError = true;
		if (!this.props.classPresident) classPresidentError = true;
		if (!this.props.classPhone) classPhoneError = true;
		if (!emailValid(this.props.classEmail)) classEmailError = true;
		if (!this.props.dateProm) datePromError = true;
		if (!this.props.guestsNumber) guestsNumberError = true;
		// New regular fields
		if (!this.props.phone) phoneError = true;
		if (!this.props.dateEvent) dateEventError = true;
		if (!this.props.typeEvent) typeEventError = true;
		// Original fields
		if (!this.props.name) nameError = true;
		if (!emailValid(this.props.email)) invalid = true;
		if (!this.props.msg) msgError = true;

		if (!schoolNameError &&
			!classNameError &&
			!commPresidentError &&
			!commPhoneError &&
			!commEmailError &&
			!classPresidentError &&
			!classPhoneError &&
			!classEmailError &&
			!datePromError &&
			!guestsNumberError &&
			!phoneError &&
			!dateEventError &&
			!typeEventError &&
			!nameError && !invalid && !msgError) {
			this.props.sendContact();
		}

		this.setState({
			// New fields
			schoolNameError,
			classNameError,
			commPresidentError,
			commPhoneError,
			commEmailError,
			classPresidentError,
			classPhoneError,
			classEmailError,
			datePromError,
			guestsNumberError,
			// New regular fields
			phoneError,
			dateEventError,
			typeEventError,
			// Original fields
			nameError,
			invalid,
			msgError
		});
	}

	_renderLoadOrButton(){
		if(this.props.status === 'loading') return <FadeLoader color={'#462177'} loading={true} />
		else return <Button onClick={() => this._send()} className="bt bt-primary">ENVIAR</Button>
	}

	_renderInvalid() {
		if (this.state.invalid || this.state.commEmailError || this.state.classEmailError) {
			return (
				<Alert className="sp-msg sp-danger">
					Correo electrónico no válido.
				</Alert>
			)
		}
	}

	_renderFieldsInvalid() {
		if (this.state.nameError || this.state.schoolNameError) {
			return (
				<Alert className="sp-msg sp-danger">
					¡Rellene todos los campos!
				</Alert>
			)
		}
	}

	_renderSended() {
		if (this.props.status === 'ok') {
			return (
					<Alert className="sp-msg sp-success">
						¡Mensaje enviado!
						<Button onClick={() => this._goHome()}>X</Button>
					</Alert>
			)
		}
	}

	_renderErrorReq() {
		if (this.props.status === 'error') {
			return (
				<Alert className="sp-msg sp-danger">
					Error al enviar, vuelva a intentarlo más tarde
				</Alert>
			)
		}
	}

	render() {
		return (
			<div className="sp-page">
				<Navbar className="sp-nav">
					{/* <div className="sp-bk ico-sp-cvleft" onClick={() => this._goBack()}></div> */}
					<div className="sp-label">Contacto</div>
					<div>&nbsp;</div>
				</Navbar>

				<Container className="sp-content contacto">
					<Row>
						{/* MSG Valid */}
						{this._renderInvalid()}
						{this._renderFieldsInvalid()}
						{this._renderErrorReq()}
						{this._renderSended()}

						{/* New fields */}
						<Input
							placeholder="Nombre de la escuela"
							type="email"
							invalid={this.state.schoolNameError}
							value={this.props.schoolName}
							onChange={e => this.props.inputSchoolName(e.target.value)}
							required
						/>
						<Input
							placeholder="Nombre de la clase"
							type="email"
							invalid={this.state.classNameError}
							value={this.props.className}
							onChange={e => this.props.inputClassName(e.target.value)}
							required
						/>
						<Input
							placeholder="Presidente del comité de padres"
							type="email"
							invalid={this.state.commPresidentError}
							value={this.props.commPresident}
							onChange={e => this.props.inputCommitteePresident(e.target.value)}
							required
						/>
						<Input
							placeholder="Teléfono"
							type="email"
							invalid={this.state.commPhoneError}
							value={this.props.commPhone}
							onChange={e => this.props.inputCommitteePhone(e.target.value)}
						/>
						<Input
							placeholder="E-mail"
							type="email"
							invalid={this.state.commEmailError}
							value={this.props.commEmail}
							onChange={e => this.props.inputCommitteeEmail(e.target.value)}
						/>
						<Input
							placeholder="Presidente de la clase graduanda"
							type="email"
							invalid={this.state.classPresidentError}
							value={this.props.classPresident}
							onChange={e => this.props.inputClassPresident(e.target.value)}
						/>
						<Input
							placeholder="Teléfono"
							type="email"
							invalid={this.state.classPhoneError}
							value={this.props.classPhone}
							onChange={e => this.props.inputClassPhone(e.target.value)}
						/>
						<Input
							placeholder="E-mail"
							type="email"
							invalid={this.state.classEmailError}
							value={this.props.classEmail}
							onChange={e => this.props.inputClassEmail(e.target.value)}
						/>
						<Input
							placeholder="Fecha para el prom"
							type="email"
							invalid={this.state.datePromError}
							value={this.props.dateProm}
							onChange={e => this.props.inputDateProm(e.target.value)}
						/>
						<Input
							placeholder="Cantidad de invitados"
							type="email"
							invalid={this.state.guestsNumberError}
							value={this.props.guestsNumber}
							onChange={e => this.props.inputGuestsNumber(e.target.value)}
						/>
						{/* Original fields */}
						<Input
							placeholder="Nombre"
							type="email"
							invalid={this.state.nameError}
							value={this.props.name}
							onChange={e => this.props.inputName(e.target.value)}
						/>
						<Input
							placeholder="E-Mail"
							type="email"
							invalid={this.state.invalid}
							value={this.props.email}
							onChange={e => this.props.inputEmail(e.target.value)}
						/>
						{/* New regular fields */}
						<Input
							placeholder="Teléfono"
							type="email"
							invalid={this.state.phoneError}
							value={this.props.phone}
							onChange={e => this.props.inputPhone(e.target.value)}
						/>
						<Input
							placeholder="Fecha del evento"
							type="email"
							invalid={this.state.dateEventError}
							value={this.props.dateEvent}
							onChange={e => this.props.inputDateEvent(e.target.value)}
						/>
						<Input
							placeholder="Tipo de evento"
							type="email"
							invalid={this.state.typeEventError}
							value={this.props.typeEvent}
							onChange={e => this.props.inputTypeEvent(e.target.value)}
						/>
						<textarea
							name=""
							id=""
							cols="30"
							rows="5"
							placeholder="Mensaje"
							className={this.state.msgError ? 'is-invalid' : ''}
							value={this.props.msg}
							onChange={e => this.props.inputMsg(e.target.value)}>
						</textarea>
						{this._renderLoadOrButton()}
					</Row>
				</Container>
			</div>
		);
	}
}

const mapStateToProps = state => (
	{
		// New fields
		schoolName: state.ContactReducer.schoolName,
		className: state.ContactReducer.className,
		commPresident: state.ContactReducer.commPresident,
		commPhone: state.ContactReducer.commPhone,
		commEmail: state.ContactReducer.commEmail,
		classPresident: state.ContactReducer.classPresident,
		classPhone: state.ContactReducer.classPhone,
		classEmail: state.ContactReducer.classEmail,
		dateProm: state.ContactReducer.dateProm,
		guestsNumber: state.ContactReducer.guestsNumber,
		// New regular fields
		phone: state.ContactReducer.phone,
		dateEvent: state.ContactReducer.dateEvent,
		typeEvent: state.ContactReducer.typeEvent,
		// Original fields
		name: state.ContactReducer.name,
		email: state.ContactReducer.email,
		msg: state.ContactReducer.msg,
		status: state.ContactReducer.status
	}
)

const mapActions = {
	// New fields
	inputSchoolName,
	inputClassName,
	inputCommitteePresident,
	inputCommitteePhone,
	inputCommitteeEmail,
	inputClassPresident,
	inputClassPhone,
	inputClassEmail,
	inputDateProm,
	inputGuestsNumber,
	// New regular fields
	inputPhone,
	inputDateEvent,
	inputTypeEvent,
	// Original fields
	inputName,
	inputEmail,
	inputMsg,
	sendContact,
	getContactDB,
	setContactStatus
};

export default withRouter(connect(mapStateToProps, mapActions)(Contact));


// WEBPACK FOOTER //
// ./src/screens/Contact.js